import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import { isEmpty } from '@wconcept/wconcept-common/utils/baseUtils';

import {
  IconArrowRight01,
  IconArrowDown04,
  IconArrowDown05,
  IconRefresh01,
} from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import { sanitizeContent } from '@wconcept/wconcept-common/utils/htmlSanitizer';
import * as S from './style';

interface IProps {
  /** className */
  className?: string;
  /** type */
  type?:
    | 'line'
    | 'lineIcon'
    | 'lineDropdown'
    | 'blackLineIcon'
    | 'grayLineIcon'
    | 'black'
    | 'orange'
    | 'dropdown'
    | 'shortcut'
    | 'refresh'
    | 'grayDropdown'
    | 'transparentWhite'
    | undefined;
  /** size */
  size?: 'medium' | 'large' | undefined;
  /** beforeIcon */
  beforeIcon?: React.ReactNode;
  afterIcon?: React.ReactNode;
  /** text */
  text: string | React.ReactNode;
  /** ellipsisText */
  ellipsisText?: string;
  /** disabled */
  disabled?: boolean;
  /** onClick */
  onClick?: () => void;
}

const BasicBtn = ({
  className,
  type = 'line',
  size = 'medium',
  beforeIcon,
  afterIcon,
  text,
  ellipsisText,
  disabled,
  onClick,
}: IProps) => {
  const param = {
    className: classNameBind(['basic-btn', className || '']),
    $type: type,
    $size: size,
    onClick,
    disabled,
  };

  return (
    <S.BasicBtn {...param}>
      {!isEmpty(beforeIcon) && (
        <span className="icon-before">{beforeIcon}</span>
      )}
      {type === 'refresh' && (
        <span className="icon-refresh">
          <IconRefresh01 />
        </span>
      )}
      <span className="text">
        {ellipsisText && (
          <span
            dangerouslySetInnerHTML={{
              __html: sanitizeContent(ellipsisText),
            }}
            className="area-ellipsis"
          />
        )}
        <span className="inner-text">{text}</span>
        {!isEmpty(afterIcon) && <span className="icon-after">{afterIcon}</span>}
      </span>
      {(type === 'lineIcon' ||
        type === 'blackLineIcon' ||
        type === 'grayLineIcon' ||
        type === 'orange' ||
        type === 'shortcut') && (
        <span className="icon-arrow">
          <IconArrowRight01 />
        </span>
      )}
      {type === 'lineDropdown' && (
        <span className="icon-arrow">
          <IconArrowDown05 />
        </span>
      )}
      {(type === 'dropdown' || type === 'grayDropdown') && (
        <span className="icon-arrow">
          <IconArrowDown04 />
        </span>
      )}
    </S.BasicBtn>
  );
};

export default BasicBtn;
